<template>
  <AiCompanionDialog :visible="visible" @closed="handleCloseDialog" class="opc-aic-learn-more-dialog" />
</template>

<script>
import { ConfirmComponent } from '../common/service-dialog/confirm';
import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';
import { AiCompanionDialog } from '@zoom/fe-billing-components';

export default {
  name: 'CompanionBanner',
  mixins: [ConfirmComponent],
  components: {
    AiCompanionDialog
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    visible(val) {
      if (this.$context && this.$context.is && this.$context.is.modal) {
        val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
      }
    }
  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
    handleCloseDialog() {
      this.visible = false;
    },
    handleOpen() {
      this.visible = true;
    },
    async handleSure() {
      this.visible = false;
      return Promise.resolve();
    },
    async handleCancel() {
      this.visible = false;
      return Promise.resolve();
    }
  }
};
</script> 

<style lang="scss">
.opc-aic-learn-more-dialog {
  .plan-lm-dialog__interaction__intro-list {
    li {
      b {
        font-weight: 600;
      }
    }
  }
}
</style>